import React from 'react';

export default function PaceAnalytics({ analytics, sessionPhase }) {
  if (!analytics) return null;

  const onTrack = analytics.onTrack;
  const eta = analytics.etaMinutes;

  return (
    <div className="card pace-analytics-card">
      <h3>📊 गति विश्लेषण / Pace Analytics</h3>
      {sessionPhase && (
        <div className="pace-session">सत्र: {sessionPhase.label || sessionPhase.phase}</div>
      )}
      <div className="stats-grid">
        <div className="stat-box">
          <div className="label">जीत दर / Win rate</div>
          <div className={`value ${analytics.winRate >= 50 ? 'green' : ''}`}>{analytics.winRate}%</div>
        </div>
        <div className="stat-box">
          <div className="label">औसत लाभ / Avg win</div>
          <div className="value green">₹{analytics.avgWin}</div>
        </div>
        <div className="stat-box">
          <div className="label">औसत हानि / Avg loss</div>
          <div className="value red">₹{analytics.avgLoss}</div>
        </div>
        <div className="stat-box">
          <div className="label">गति / Pace per hr</div>
          <div className="value gold">₹{analytics.pacePerHour}</div>
        </div>
        <div className="stat-box">
          <div className="label">चाहिए / Need per hr</div>
          <div className="value">₹{analytics.neededPacePerHour}</div>
        </div>
        <div className="stat-box">
          <div className="label">बाजार बाकी / Mins left</div>
          <div className="value">{analytics.marketMinutesLeft}m</div>
        </div>
      </div>
      <div className={`pace-banner ${onTrack ? 'on-track' : 'behind'}`}>
        {analytics.paceLabelHi}
        {eta != null && eta > 0 && onTrack && (
          <span> — अनुमान ~{eta} मिनट में लक्ष्य</span>
        )}
        {analytics.targetHitAt && (
          <span> — लक्ष्य समय: {analytics.targetHitAt}</span>
        )}
      </div>
    </div>
  );
}
